<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col">
        <h2>Sündmuste logi</h2>
        <div v-if="alarms.length > 0" class="mb-2" :class="{'opacity-50 blur': loading}">
          <!--
          Kuvatav periood: {{  moment(parseInt(this.alarms[0].raised_at)).format("DD.MM.YYYY HH:mm") }} kuni {{  moment(parseInt(this.alarms[limit - 1].raised_at)).format("DD.MM.YYYY HH:mm") }}
          -->
        </div>
        <table class="table">
          <thead>
          <th>Alarm</th>
          <th>Algus</th>
          <th>Lõpp</th>
          </thead>
          <tbody :class="{'opacity-50 blur': loading}">
          <tr v-for="alarm in alarms" :key="alarm.id">
            <td>
              {{ alarm.name }}
              <small class="d-block" v-if="alarm.description !== null">{{ alarm.description }}</small>
              <small class="d-block">
                <span v-for="group in orderBy(alarm.groups_ids, 'group')" :key="group" class="badge me-1" :style="'background-color: ' + groupInfo(group).color + ';'">{{ groupInfo(group).short }}</span>
              </small>
            </td>
            <td>{{  moment(parseInt(alarm.raised_at)).format("DD.MM.YYYY HH:mm") }}</td>
            <td>
              <span v-if="alarm.cleared_at !== null">{{  moment(parseInt(alarm.cleared_at)).format("DD.MM.YYYY HH:mm") }}</span>
            </td>
          </tr>
          </tbody>
        </table>
        <button class="btn btn-outline-primary" v-if="page !== 0" @click="page = page - 1">&laquo; Uuemad</button>
        <button class="btn btn-outline-primary float-end" v-if="limit <= alarms.length" @click="page = page + 1">Vanemad &raquo;</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Vue2Filters from 'vue2-filters'

export default {
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      page: 0,
      limit: 25,
      alarms: [],
      loading: false
    }
  },
  watch: {
    page: function () {
      this.loading = true
      this.getAlarms()
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    this.getAlarms()
  },
  methods: {
    // Load alarms from DB
    getAlarms () {
      const token = localStorage.getItem('localToken')
      axios.get(this.$store.getters.apiUrl + '/getAlarmLogList?page=' + this.page + '&count=' + this.limit, { headers: { Authorization: `${token}`, 'Project-Name': this.$store.state.project.code } })
        .then((response) => {
          this.alarms = response.data
          // lol
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // Return group info based on ID
    groupInfo (id) {
      const group = this.$store.state.groups.find(obj => obj.id === id)
      if (group === undefined) {
        return {}
      } else {
        return group
      }
    }
  }
}
</script>
